// opervex-frontend/src/routes/index.js

import commonRoutes from "./commonRoutes";
import reportRoutes from "./reportRoutes";
import registerRoutes from "./registerRoutes";
import systemRoutes from "./systemRoutes";
import accountingRoutes from "./accountingRoutes";
import financialRoutes from "./financialRoutes";
import hrRoutes from "./humanResourcesRoutes";
import mmRoutes from "./materialManagementRoutes";
import serviceManagement from "./serviceManagementRoutes";
import others from "./others";

const Routes = [
  ...commonRoutes,
  ...reportRoutes,
  ...registerRoutes,
  ...systemRoutes,
  ...accountingRoutes,
  ...financialRoutes,
  ...hrRoutes,
  ...mmRoutes,
  ...serviceManagement,
  ...others,
];

export default Routes;
